import request from "../../Request";
import authStore from "../../../Stores/AuthStore/AuthStore";
import {rThen} from "../../requestThen";

export let getChildInvite = async (memberId) => {

    return request.get(`/api/children_group/get_invite/${authStore.decodeJwt.userId}/${memberId}`, true).then(r => {
        return rThen(r)
    })
}